import React from 'react'
import { useIntl } from 'react-intl'
import { IBreadcrumb } from '@notino/react-styleguide'

// components
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import PassDetail from './components/PassDetail/PassDetail'
import MyPassPageHead from './components/MyPassPageHead/MyPassPageHead'
import OverlayLoading from '../../atoms/OverlayLoading/OverlayLoading'

// types
import { BasePageQuery, PageProps, PassResponse } from '../../types/types'

// hooks
import useMessages from '../../hooks/useMessages'

// styles
import * as SC from './MyPassPageStyles'

// utils
import createPageContainer from '../../utils/createPageContainer'
import { PAGE_LINKS } from '../../utils/helper'

type RouteProps = {
	passID: string
}

type MyPassPageData = {
	passData: PassResponse
}

type MyPassPageProps = PageProps<MyPassPageData, BasePageQuery, RouteProps>

const MyPassPage = (props: MyPassPageProps) => {
	const { passID, passData, isFetching } = props
	const { messages } = useMessages()
	const { locale } = useIntl()

	const breadcrumbItems: IBreadcrumb[] = [
		{ link: PAGE_LINKS['/salons/passes'](locale), name: messages['Your Passes'] },
		{ link: '', name: passData.pass.service.name ?? messages['My pass'] }
	]

	return (
		<>
			<MyPassPageHead serviceName={passData.pass.service.name} />
			<SC.PageContainer>
				<Breadcrumb breadcrumbItems={breadcrumbItems} hasSalonsBreadcrumb />
				<SC.MainContent>
					<OverlayLoading isLoading={isFetching}>
						<PassDetail pass={passData.pass} passID={passID} />
					</OverlayLoading>
				</SC.MainContent>
			</SC.PageContainer>
		</>
	)
}

const MyPassPageContainer = createPageContainer<MyPassPageData, BasePageQuery, RouteProps>({
	identifier: 'MyPassPage',
	PageComponent: MyPassPage,
	initDefaultData: async ({ api, passID }) => {
		const passData = await api.b2c.getPassData(passID)

		return { passData }
	}
})

export default MyPassPageContainer
